import { render, staticRenderFns } from "./webView.vue?vue&type=template&id=064d7b51&scoped=true&"
import script from "./webView.vue?vue&type=script&lang=js&"
export * from "./webView.vue?vue&type=script&lang=js&"
import style0 from "./webView.vue?vue&type=style&index=0&id=064d7b51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d7b51",
  null
  
)

export default component.exports